import React, { useRef } from "react";
import { Container, ImgBox1, TextBox1 } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com1 = () => {
  const ref1 = useRef();
  const ref2 = useRef();

  useScrollFadeIn(ref1, ref2);
  return (
    <Container ref={ref2} className="fade-in">
      <TextBox1>
        <div>Community Home</div>
        <div>
          Sketch의 다양한 소셜 미디어를 팔로우하고 최신 뉴스를 실시간으로 확인하며 Sketch가 제공하는 자료를 확인하세요.
        </div>
      </TextBox1>
      <ImgBox1 loading="lazy">
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/79d5ff3bCommunityHome_1.svg"
          alt="community"
          ref={ref1}
          className="fade-in"
        />
      </ImgBox1>
    </Container>
  );
};

export default Com1;
